export default "__VITE_ASSET__DAaBOOm9__"